import React, { FC } from 'react';
import { ProjectId } from 'api/models';
import {
  ConversationType,
  useActiveConversationType,
} from '../../proj-conversation-hooks';
import { ProjectConversationPaneWrapper } from './project-conversation';
import { ProjectGlobalConversationPaneWrapper } from './project-global-conversation';

interface Props {
  projectId: ProjectId;
}

export const ProjectConversationPane: FC<Props> = ({ projectId }) => {
  const conversationType = useActiveConversationType();

  if (conversationType === ConversationType.Project) {
    return <ProjectConversationPaneWrapper projectId={projectId} />;
  }

  return <ProjectGlobalConversationPaneWrapper projectId={projectId} />;
};
